import { render, staticRenderFns } from "./EditBookingHoursPolicy.vue?vue&type=template&id=78ec3887&"
import script from "./EditBookingHoursPolicy.vue?vue&type=script&lang=js&"
export * from "./EditBookingHoursPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports